import _slicedToArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRef, useState } from 'react';
export var useListboxControls = function useListboxControls(_ref) {
  var onChange = _ref.onChange,
      isMultiSelectable = _ref.isMultiSelectable,
      itemIdPrefix = _ref.itemIdPrefix;
  var listBoxRef = useRef(null);
  var activeDescendant = useRef(null);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      activeDescendantId = _useState2[0],
      setActiveDescendantId = _useState2[1];

  var setupFocus = function setupFocus() {
    focusFirstItem();
  };

  var focusFirstItem = function focusFirstItem() {
    var firstItem;
    firstItem = listBoxRef.current.querySelector("[id*=\"".concat(itemIdPrefix, "\"]"));

    if (firstItem) {
      focusItem(firstItem);
    }
  };

  var focusItem = function focusItem(element) {
    if (element.id === 'scrollShadowTop' || element.id === 'scrollShadowBottom') {
      return;
    }

    activeDescendant.current = element;
    setActiveDescendantId(element.id);

    if (listBoxRef.current.scrollHeight > listBoxRef.current.clientHeight) {
      // tslint:disable-next-line
      var scrollBottom = listBoxRef.current.clientHeight + listBoxRef.current.scrollTop; // tslint:disable-next-line

      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listBoxRef.current.scrollTop = elementBottom - listBoxRef.current.clientHeight;
      } else if (element.offsetTop < listBoxRef.current.scrollTop) {
        listBoxRef.current.scrollTop = element.offsetTop;
      }
    }
  };

  var handleKeyDown = function handleKeyDown(event, options) {
    var nextItem = activeDescendant;

    if (!nextItem.current) {
      return;
    }

    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault();
        nextItem = nextItem.current.previousElementSibling;

        if (nextItem) {
          focusItem(nextItem);
        }

        break;

      case 'ArrowDown':
        event.preventDefault();
        nextItem = nextItem.current.nextElementSibling;

        if (nextItem) {
          focusItem(nextItem);
        }

        break;

      case 'Enter':
      case ' ':
        event.preventDefault();
        toggleSelectedItem(nextItem.current, options);
        break;

      default:
        return;
    }
  };

  var toggleSelectedItem = function toggleSelectedItem(element, options) {
    onChange(getOption(element.id, options));
  };

  var getOption = function getOption(elementId, options) {
    return options.find(function (_ref2) {
      var id = _ref2.id;
      return id === elementId;
    });
  };

  var handleClick = function handleClick(event, options) {
    event.preventDefault();
    var target = event.target;
    if (!event.target) return;
    target = event.target.closest("[id*=\"".concat(itemIdPrefix, "\"]"));

    if (isMultiSelectable && target.id.indexOf(itemIdPrefix) > -1) {
      focusItem(target);
      toggleSelectedItem(target, options);
    } else {
      setActiveDescendantId('');
      toggleSelectedItem(target, options);
    }
  };

  var handleBlur = function handleBlur() {
    setActiveDescendantId('');
  };

  return {
    listBoxRef: listBoxRef,
    activeDescendant: activeDescendant,
    activeDescendantId: activeDescendantId,
    handleClick: handleClick,
    handleKeyDown: handleKeyDown,
    setupFocus: setupFocus,
    handleBlur: handleBlur
  };
};